import React from 'react';

import {Grid, Row} from 'react-bootstrap';
//import {AppBar, TextField, RaisedButton } from 'material-ui';

import MovieList from './movie-list/movie-list.component';
import * as scrollHelpers from '../common/scroll.helpers';

//import MovieSearchComponent from './movie-search/movie-search.component';

import PropTypes from 'prop-types';
//import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
//import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
//import TextFieldMUI from '@material-ui/core/TextField';
import AccountCircle from '@material-ui/icons/AccountCircle';
import SearchIcon from '@material-ui/icons/Search';
import Button from '@material-ui/core/Button';
//import Paper from '@material-ui/core/Paper';
import Grid2 from '@material-ui/core/Grid';
import MovieCategories from './movieCategories'; 
//import classNames from 'classnames';
//import Avatar from '@material-ui/core/Avatar';
//import { Jumbotron, Container, CardColumns, CardImg,  Card } from 'reactstrap';
//import logo from './images/joobster.jpg'; 
import Swal from 'sweetalert2';
import '../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../../i18n'
import { withTranslation } from 'react-i18next'
import Questionaire from './Questionaire';
const settings = require('../../settings');




const gridstyles = theme => ({
  root: {
    flexGrow: 1,
  },

  paper: {
    height: 140,
    width: 100,
  },
  

});

const appbarstyles = {
  root: {
    flexGrow: 1,
  },
};


const avatarstyles = {
  row: {
    display: 'flex',
    justifyContent: 'center',
  },
  avatar: {
    margin: 10,
  },
  bigAvatar: {
    width: 60,
    height: 60,
  },
};



const styles = theme => ({
  root: {
    width: '100%',     
    
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular

  },

  column: {
    flexBasis: '45%'
  }, 

  margin: {
    margin: theme.spacing.unit,    
    //margin: 'auto', 

  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },

  button: {
    margin: theme.spacing.unit,
    
  }, 

  center: {
    margin: 'auto'

  }


});



class MovieBrowser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      urlvalue: [], 
      choosenidvalue: null, 
      surveys: [], 
      mainquestion: '', 
      starquestions: [], 
      openquestions: [], 
      ssmsquestions: [],  
      choosenclips: [] , 
      choosenimages: [],    
      ratingicons: null, 
      logo: "", 
      langcode: '', // fallback is always english as in i18n.js defined
    };


    this.handleKeyPress = this.handleKeyPress.bind(this);


  }









 async componentDidMount(){

  var UrlValue = this.getHashFromUrl();
  var langCode = this.getLanguageFromUrl();
  var IDUrlParameterValue = null

  this.changeLanguage(langCode)
  await this.setState({
    urlvalue: UrlValue, 
    language: langCode, 
    //logo: "https://www.joobster.at/wp-content/uploads/2018/05/joobster_logo_black-1024x460.jpg"
  })
  console.log('url value is: ', this.state.urlvalue)


await this.getSurveyFromJoobsterServer()




 }


 getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
      vars[key] = value;
  });
  return vars;
}


getLanguageFromUrl() {

  //console.log('Language is:  ', this.getUrlVars()['languageCode'])

  return this.getUrlVars()['languageCode'];
}


 getHashFromUrl() {

  //console.log('HASH URL IS: ', this.getUrlVars()['questionhash'])

  return this.getUrlVars()['questionhash'];
}


  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  changeLanguage = (langCode) => {

    this.props.i18n.changeLanguage(langCode)
  }

  
 async getSurveyFromJoobsterServer(){
 
  const {t} = this.props;

  await   fetch(settings.internalsurveypath + '/' + this.state.urlvalue ,  {
       method: 'GET',
       headers: {
       'Content-Type': 'application/json',
       //'Authorization' : 'Bearer ' + this.props.auth.sessionId
       
       },
     }).then((res) => res.json())
     .then( async (data) => { 
   
   

      var localmainquestion = '';
      var localstarquestions = [];
      var localopenquestions = [];
      var localssmsquestions = [];
      var localchoosenclips = [];
      var localchoosenimages = [];

       if (data.survey.resources[0].type == "text"){
          localmainquestion = data.survey.resources[0].text;
      }

      if (data.survey.resources[0].type == "video"){
        var videosurvey = data.survey.resources[0];
        localchoosenclips.push( {          
            id: videosurvey.id,
            title: videosurvey.text,             
            subtitle: videosurvey.createDate, 
            video: {
              videoThumbLow: videosurvey.image, 
              videoLow: videosurvey.video, 
            }
          }
        );
      //  console.log('VIDEO DATA IS: ', localchoosenclips)
      }

      if (data.survey.resources[0].type == "image"){
        localchoosenimages.push({ id: data.survey.id, link: data.survey.resources[0].image, title: data.survey.resources[0].text, subtitle: data.survey.resources[0].createDate });
     //  localchoosenimages.push({ id: "5d0e4c7c1c3a7f173ec22330", link: 'https://cdn2-demo.joobster.at/survey/5d0e4c691c3a7f173ec2232d/5d0e4c7c1c3a7f173ec22330.png', 
     //  title: "joobster_micro_funktionsgrafik.png", 
     //  subtitle: "0001-01-01T00:00:00Z" });
      }      


     data.survey.starQuestions.map( f => localstarquestions.push({ question: f.question, id: f.id }));
     data.survey.openQuestions.map(f => localopenquestions.push({ question: f.question, id: f.id}));
     
     
    localssmsquestions = data.survey.ssmsQuestions && data.survey.ssmsQuestions.length>0 ? data.survey.ssmsQuestions : [];

/*
     
     localssmsquestions = 
     [{
      "index": 4,
      "value": "Was trifft zu?",
      "qtype": "ms",
      "answers": [
        {
          "index": 3,
          "value": "Er kennt die Frau seiner Mutter",
          "qtype": "ms-ss",
          "answers": [],
          "answer": false
        },        
        {
        "index": 2,
        "value": "Das Hemd ist braun",
        "qtype": "ms-ss",
        "answers": [],
        "answer": false
      }, {
        "index": 1,
        "value": "Sein Name ist Hofer",
        "qtype": "ms-ss",
        "answers": [],
        "answer": true
      }],
      "answer": true
    }, 
    {
      "index": 3,
      "value": "Sind mehr als 5 Artikel zu sehen?",
      "qtype": "ss",
      "answers": [],
      "answer": true
    },
    {
      "index": 2,
      "value": "Ist das Hemd rot",
      "qtype": "ss",
      "answers": [],
      "answer": true
    }, {
      "index": 1,
      "value": "Ist das der Petrus",
      "qtype": "ss",
      "answers": [],
      "answer": true
    }]
  
*/



     

      await this.setState({
         surveys: data.survey, 
         mainquestion: localmainquestion, 
         choosenclips: localchoosenclips, 
         choosenimages: localchoosenimages,
         starquestions: localstarquestions, 
         openquestions: localopenquestions, 
         ssmsquestions: localssmsquestions, 
         logo: data.survey.logo, 
         ratingicons: data.survey.ratingIcons
       })
 
     //  console.log('state is: ', this.state)
 
 
       Swal.fire({
         position: 'top-end',
         type: 'success',
         title: t('mainsite.surveyloadedsuccessful'),
         showConfirmButton: false,
         timer: 1500
       })   		
     })
     .catch((err)=>{
       Swal.fire({
         title: t('mainsite.surveyloadingerrortitle'),
         position: 'center',
         text: t('mainsite.surveyloadingerrortext'),
         type: 'error',
         animation: true,
         customClass: {
           popup: 'animated tada'
         },       
         showConfirmButton: false, 
         timer: 1500
         //confirmButtonText: 'Cool'
       }) 		
     });	  
   
   



   }
 

 
 




handleKeyPress(event){
  if(event.key == 'Enter'){    
    this.searchFieldClicked();
  }
}



   render() {

    const {t} = this.props;

    return (
      <div>
 


 <div className={styles.root}>
      <ExpansionPanel defaultExpanded={true}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>    
        <div className={styles.column}>        
    <img top="true" width="10%"   src={this.state.logo ? this.state.logo : 'https://www.joobster.at/wp-content/uploads/2018/05/joobster_logo_black-1024x460.jpg'} alt="Firmenlogo" />  {this.state.surveys.hasAnswers ? t('mainsite.knowledgecheck') : t('mainsite.surveytext')}
        </div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>


              <Grid2 container className={styles.container} >
                <Grid2 item xs={12} >
                  <Grid2 container spacing={16} alignitems="center" justify="center" direction="row" >

                    
                    {this.state.surveys.hasAnswers ? <p>{t('mainsite.yourknowledge')}</p> : <p>{t('mainsite.youropinion')}</p>}
                  </Grid2>
                </Grid2>
              </Grid2>
            
      
            
        </ExpansionPanelDetails>
      </ExpansionPanel>
      </div>
    
       {
        ( this.state.mainquestion != '' || this.state.choosenimages.length >0 || this.state.choosenclips.length >0 || this.state.openquestions.length>0 || this.state.starquestions.length>0 || this.state.ssmsquestions.length >0) ?
      <Questionaire ratingicons={this.state.ratingicons} buttonLabel={this.state.surveys.hasAnswers ? t('mainsite.heretoknowledgecheck') : t('mainsite.heretosurvey')} surveytype={this.state.surveys.hasAnswers ? 1 : 0} type={this.state.surveys.resources[0].type} color="primary" urlhash={this.state.urlvalue} mainquestion={this.state.mainquestion} mainpictures={this.state.choosenimages} mainclips={this.state.choosenclips} openquestions={this.state.openquestions} starquestions={this.state.starquestions} ssmsquestions={this.state.ssmsquestions}/>
      : null
       }
      </div>
    );



  }

  
}

MovieBrowser.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default  withTranslation()(MovieBrowser);




// WEBPACK FOOTER //
// ./src/modules/movie-browser/movie-browser.container.js